/* eslint-disable no-restricted-globals */
import React, { useContext } from "react";
import { StoreContext } from "components/StoreContext";
import Loading from "components/Loading";
import HeadTags from "components/HeadTags";

const ContactUs = () => {
  const { config } = useContext(StoreContext);
  if (config.loaded) {
    return (
      <>
        <HeadTags title="Contact Us" />
        <div className="contentPage">
          <div className="contentPage__headingDiv">
            <h1>Contact Us</h1>
            <h6>
              Send us a message and we’ll respond as soon as possible. If you
              need immediate support, try using our live chat feature.
            </h6>
          </div>
          <div className="contentPage__contactUs">
            <iframe
              id="contactForm"
              title="Contact Us"
              src={config.contactUsPardotForm}
            />
          </div>
        </div>
      </>
    );
  }
  return <Loading />;
};

export default ContactUs;
